"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

/**
 * Back-compat shim: sign-up round trips that started before the dedicated
 * /checkout page shipped return here with `?openCheckout=<processor_plan_id>`.
 * Forward them to the checkout page (replace, so Back can't re-trigger it).
 *
 * Renders nothing. Must be wrapped in <Suspense> (useSearchParams).
 */
export function LegacyOpenCheckoutRedirect() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (redirectedRef.current) {
      return;
    }
    const processorPlanId = searchParams.get("openCheckout");
    if (!processorPlanId) {
      return;
    }
    redirectedRef.current = true;
    router.replace(`/checkout?plan=${encodeURIComponent(processorPlanId)}`);
  }, [searchParams, router]);

  return null;
}
